import { User } from '../../../models';
import { cookieService, localStorageFuncs } from '../../helpers';
import { decodeJwtPayload } from '../../helpers/jwt.utils';
import ApiService from '../apiTemplate/api';

import { Token } from './auth.api.types';

class AuthService extends ApiService {
	constructor() {
		super();
		this.credentials = 'include';
		this.endPoint = `${this.endPoint}/auth`;
		this.redirect = 'follow';
		this.setHeaders([
			{
				key: 'Accept',
				value: 'application/json',
			},
			{
				key: 'Content-Type',
				value: 'application/json',
			},
		]);
	}

	/**
	 * Check le status de la connexion du compte avec le SSO
	 */
	public async checkStatusLoginSSO() {
		this.setMethod('GET');
		try {
			const request = await fetch(`${this.endPoint}/check-auth`, {
				credentials: 'include',
				method: 'GET',
			});
			return request.status === 200;
		} catch (err) {
			console.error(`Unable to connect due to --> ${err}`);
			return false;
		}
	}

	/**
	 * Retourne les informations utilisateur en fonction du token présent dans les cookies retourné par le SSO.
	 * @returns {User}
	 */
	public async checkLoginSSO() {
		try {
			const userToken = cookieService.getCookie('authorization');

			const statusLoginSSO = await this.checkStatusLoginSSO();

			if (userToken && statusLoginSSO) {
				return this.getJwtToUser(userToken);
			} else {
				return null;
			}
		} catch (err) {
			throw new Error(`login failed due to --> ${err}`);
		}
	}

	/**
	 * logout
	 */
	public async logout() {
		this.setMethod('GET');
		try {
			await fetch(`${this.endPoint}/logout`, {
				credentials: 'include',
				mode: 'no-cors',
			});
			localStorageFuncs.del('smtr-appEnv');
		} catch (err) {
			throw new Error(`logout failed due to --> ${err}`);
		}
	}

	private getJwtToUser(token: string): User {
		const decoded = decodeJwtPayload<Token>(token);
		if (!decoded?.payload) throw new Error('Invalid token');
		return decoded.payload;
	}
}

export const authService = new AuthService();
